import swal from "sweetalert";

import { InitPage } from "../index";

declare var postingDateUrl: string;
declare var inProgressStatusUrl: string;
declare var pendingStatusUrl: string;

class ErcPurchaseOrderReceivings {
  constructor() {
    const _this = this;
    $("document").ready(function () {
      // @ts-ignore
      $(".date_picker_gray").datepicker({ format: "yyyy-mm-dd" });

      $(".calendar-fonticon").on("click", function (e) {
        e.preventDefault();
        const elm = $(e.currentTarget.previousElementSibling);
        const visible = elm.datepicker("widget").is(":visible");
        elm.datepicker(visible ? "hide" : "show");
      });

      $("#post_date").on("change", function (e) {
        const elm: any = e.currentTarget;
        if (Date.parse(elm.value) < 0) return;

        $.ajax({
          type: "PUT",
          url: postingDateUrl.replace(":id", elm.dataset.id),
          data: { posting_date: elm.value },
          success: function () {
            swal({
              icon: "success",
              title: "Posting Date has been saved",
              timer: 1500,
            });
          },
          error: function ({ responseJSON }) {
            swal({
              icon: "error",
              title: "Error",
              text: responseJSON.errors,
              dangerMode: true,
            });
          },
        });
      });

      $("input")
        .filter((_, { name }: any) => name.match(/item/))
        .on("keyup", function () {
          // @ts-ignore
          _this.validateRowByName(this.name);
        });

      $("select")
        .filter((_, { name }: any) => name.match(/item/))
        .on("change", function (event: any) {
          const [id, index] = [...event.target.name.match(/\d+/g)].map(
            (i) => i[0],
          );
          _this.handleSelectUOM(id, index);
        });

      $(".collapse-icon").on("click", function () {
        _this.toggleItems(this);
      });

      $(".add-icon").on("click", function () {
        _this.handleAddElement(this);
      });

      $(".print-icon").on("click", function (elm: any) {
        elm.preventDefault();
        const id = elm.currentTarget.dataset.id;
        $(`#print-form-${id}`).trigger("submit");
      });
    });
  }

  toggleItems(elm: HTMLElement) {
    if ($(elm).hasClass("disable_link")) return;

    const id = $(elm).data("target").replace("#por_item_", "");
    const children = $(elm).children();
    $(elm).prev().toggle(); // Add button
    $(elm).prev().prev().toggle(); // Print button
    $(".fa-hand-o-up").not(children).toggleClass("disabled");
    $(".fa-hand-o-up").not(children).parent().toggleClass("disable_link");
    children.toggleClass("fa-hand-o-up text-primary fa-close text-danger");

    if (!children.hasClass("fa-hand-o-up")) {
      $(elm).attr("title", "Cancel");

      if ($(`#status-${id}`).text().trim() === "Pending") {
        $.ajax({
          type: "PUT",
          url: inProgressStatusUrl.replace(":id", id),
          success: function () {
            $(`#status-${id}`).text("In Progress");
            $(`#status-${id}`).attr("class", "table-status middle-status");
          },
          error: function ({ responseJSON }) {
            swal({
              icon: "error",
              title: "Error",
              text: responseJSON.errors,
              dangerMode: true,
            });
          },
        });
      }
    } else {
      $(elm).attr("title", "Receive");

      if ($(`#status-${id}`).text().trim() === "In Progress") {
        $.ajax({
          type: "PUT",
          url: pendingStatusUrl.replace(":id", id),
          success: function () {
            $(`#status-${id}`).text("Pending");
            $(`#status-${id}`).attr("class", "table-status warning-status");
          },
          error: function ({ responseJSON }) {
            swal({
              icon: "error",
              title: "Error",
              text: responseJSON.errors,
              dangerMode: true,
            });
          },
        });
      }
    }
  }

  handleSelectUOM(id: number, index: number) {
    const mu = $(`select[name="item[${id}][${index}][uom]"]`)
      .find(":selected")
      .data("mu");
    $(`#per_case-${id}-${index}`).html(mu);
  }

  validateRowByName(name: string) {
    const [id, index] = [...name.match(/\d+/g)].map((i) => i[0]);
    this.validateRow(id, index);
  }

  validateRow(id: string, index: string) {
    const total_received_qty = this.getInt(id, index, "total_received_qty");
    const number_of_pallets = this.getInt(id, index, "number_of_pallets");
    const cases_per_pallets = this.getInt(id, index, "cases_per_pallets");
    const additional_cases = this.getInt(id, index, "additional_cases") || 0;

    const total = number_of_pallets * cases_per_pallets + additional_cases;
    const icon =
      total_received_qty === total && total_received_qty !== 0
        ? "<i class='fa fa-check-circle-o text-success fa-2x'></i>"
        : "<i class='fa fa-warning text-warning fa-2x'></i>";
    $(`#valid-${id}-${index}`).html(icon);

    let valid: boolean = false;
    const regex = `valid-${id}-`;
    $("td")
      .filter((_, { id }: any) => id.match(regex))
      .each(function (_, elm) {
        const children = $(elm).children();
        if (children.hasClass("text-warning")) {
          valid = false;
          return false;
        } else if (children.hasClass("text-success")) {
          valid = true;
        }
      });

    if (valid) {
      $(`#print-${id}`).removeClass("disable_link disabled");
    } else {
      $(`#print-${id}`).addClass("disable_link disabled");
    }
  }

  handleAddElement(elm: HTMLElement) {
    const _this = this;
    const id = $(elm).data("id");
    const lastRow = $(`#table_${id} tr:last`);
    const index = lastRow.data("index") + 1;

    const newRow = lastRow.clone();
    newRow.attr("data-index", index);

    newRow.children().each(function (i, e) {
      switch (i) {
        case 0:
          _this.resetFormElement(e, id, index, "total_received_qty");
          break;

        case 1:
          const select = $(e).children();
          select.attr("name", `item[${id}][${index}][uom]`);
          select.attr("id", `item[${id}][${index}][uom]`);
          const selected = $(
            `select[name="item[${id}][${index - 1}][uom]"]`,
          ).val();
          select
            .children()
            .filter(function () {
              return $(this).val() == selected;
            })
            .prop("selected", true);

          break;

        case 2:
          _this.resetFormElement(e, id, index, "number_of_pallets");
          break;

        case 3:
          _this.resetFormElement(e, id, index, "cases_per_pallets");
          break;

        case 4:
          _this.resetFormElement(e, id, index, "additional_cases");
          break;

        case 5:
          $(e).text($(`#per_case-${id}-${index - 1}`).text());
          $(e).attr("id", `per_case-${id}-${index}`);
          break;

        case 6:
          $(e).text("");
          $(e).attr("id", `valid-${id}-${index}`);
          break;

        case 7:
          $(e).html(
            `<a title="Delete" data-toggle="tooltip" style="" class="add-icon" data-id="${id}" data-index=${index}><i class="fa fa-minus-circle fa-2x text-danger"></i></a>`,
          );
          $(e)
            .children()
            .on("click", function () {
              _this.handleRemoveElement(id, index);
            });
          break;
      }
    });

    lastRow.after(newRow);

    $(`select[name="item[${id}][${index}][uom]"]`).on("change", function () {
      _this.handleSelectUOM(id, index);
    });
  }

  handleRemoveElement(id: string, index: string) {
    $(`#table_${id} tr[data-index=${index}]`).remove();
  }

  resetFormElement(elm: HTMLElement, id: string, index: string, title: string) {
    const _this = this;
    const children = $(elm).children();
    children.attr("name", `item[${id}][${index}][${title}]`);
    children.attr("id", `item[${id}][${index}][${title}]`);
    children.val("");
    children.on("change", function () {
      _this.validateRow(id, index);
    });
  }

  getInt(id: string, index: string, label: string): number {
    const item = `input[name="item[${id}][${index}][${label}]"`;
    return parseInt($(item).val().toString());
  }
}

export function LoadPage() {
  InitPage("purchase_order_receivings", () => {
    new ErcPurchaseOrderReceivings();
  });
}
